import initialState from "../states/initial-state";
import {SET_MOBILE} from "../actions/styles.actions";

const stylesReducer = (state = initialState.styles, action) => {
    switch (action.type) {
        case SET_MOBILE:
            return {
                isMobile: action.isMobile,
                ...state.styles
            };
        default:
            return state
    }
};

export default stylesReducer;
